var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fudou-detail-component" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "fudou-records" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.fudouRecords,
              "element-loading-text": "加载中...",
              "element-loading-spinner": "el-icon-loading",
              stripe: "",
              border: "",
              "default-sort": { prop: "createTime", order: "descending" },
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                prop: "orderNo",
                label: "交易订单号",
                width: "200",
                "show-overflow-tooltip": "",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "cardId",
                label: "卡号",
                width: "150",
                "show-overflow-tooltip": "",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "cardName",
                label: "卡片名称",
                width: "150",
                "show-overflow-tooltip": "",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "type",
                label: "交易类型",
                width: "100",
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getTypeTagType(scope.row.type),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getTypeText(scope.row.type)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "amount",
                label: "福豆数量",
                width: "120",
                align: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "span",
                        { class: _vm.getAmountClass(scope.row.type) },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.formatAmount(
                                  scope.row.amount,
                                  scope.row.type
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "description",
                label: "说明",
                "min-width": "150",
                "show-overflow-tooltip": "",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "userName",
                label: "用户姓名",
                width: "120",
                "show-overflow-tooltip": "",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "phone", label: "手机号", width: "130" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "createTime",
                label: "交易时间",
                width: "180",
                sortable: "",
                formatter: _vm.formatDateTime,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fudou-summary" }, [
      _c("div", { staticClass: "summary-header" }, [
        _c("h4", { staticClass: "summary-title" }, [_vm._v("福豆使用记录")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }